import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import moment from 'moment';
import _ from 'lodash';

import Confirm from '../../../components/Confirm/Confirm';
import { toggleAutorenewal, reactivateSubscription } from '../BillingActions';
import Switch from '../../../components/Switch/Switch';
import FormattedMessage from '../../../components/FormattedMessage';
import { getLocalePrice } from '../../../util/billingUtils';

import saveIcon from '../../../assets/img/save.svg';

// Import Style
import '../Billing.scss';

// Import Style

export class Subscription extends Component {
  static defaultProps = {
    data: {},
    invoice: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      autorenewal: false,
    };

    this.switchRef = React.createRef();

    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleReactivate = this.handleReactivate.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        autorenewal: this.props.data.subscription.status === 'active',
      });
    }
  }

  handleSwitch() {
    this.setState({
      autorenewal: this.switchRef.current.checked,
    });
    this.props.toggleAutorenewal(this.switchRef.current.checked);
  }

  handleReactivate() {
    this.props.reactivateSubscription();
  }

  render() {
    const { app, reactivating, data, dashboards, allowedDashboards } = this.props;

    if (!data.subscription) {
      return <div></div>;
    }

    if (data.subscription.status == 'in_trial') {
      return (
        <div className='white_box_details'>
          <span>No active subscription yet</span>
        </div>
      );
    }

    const allowed = allowedDashboards > 0
      ? allowedDashboards
      : data.plan.meta_data && data.plan.meta_data.allowed > 0
        ? data.plan.meta_data.allowed : 0;

    return (
      <div className='white_box_details plan_info'>
        <h3>Subscription</h3>
        
        <div className='plan_type'>
          <p>
            <span>Plan:</span> {data.plan.name.replace(' Annual', '').replace(' New', '')}
          </p>
          {data.customer.card_status !== 'no_card' && !/\bcustom\b/i.test(data.subscription?.plan_id || '') && (
            <Link to="/upgrade">Change plan</Link>
          )}
        </div>

        
        <p>
          <span>Subscription type:</span> {data.plan.period_unit === 'month' ? 'Monthly' : 'Annual'} subscription
        </p>
        <p>
          <span>
            Number of <FormattedMessage id={`board`} plural="true" />:
          </span>{' '}
          {dashboards}{' '}
          {allowed > 0 ? `out of ${allowed}` : ''}
        </p>

        {data.estimation.taxes && !!data.estimation.taxes.length && (
          <p>
            <span>Amount:</span> {getLocalePrice(data.subscription, data.estimation.sub_total / 100)}
          </p>
        )}
        {data.estimation.taxes &&
          data.estimation.taxes.map((t, i) => {
            return (
              <p key={i}>
                <span>{t.description}:</span> {getLocalePrice(data.subscription, t.amount / 100)}
              </p>
            );
          })}
        {data.estimation.discounts &&
          data.estimation.discounts.map((t, i) => {
            return (
              <p key={i}>
                <span>{t.description}:</span> {getLocalePrice(data.subscription, t.amount / 100)}
              </p>
            );
          })}

        <div className='subscription_total'>
          <p>
            <span>Total amount:</span> {getLocalePrice(data.subscription, data.estimation.total / 100)}
          </p>
        </div>
        {data.customer.balances && !!data.customer.balances.length && (
          <p>
            <span>Credits:</span> {
              getLocalePrice(
                data.subscription,
                data.customer.balances && data.customer.balances[0]
                  ? (data.customer.balances[0].promotional_credits + data.customer.balances[0].refundable_credits) / 100
                  : 0
              )
            }
          </p>
        )}
        {!!data.subscription.next_billing_at ? (
          <p>
            <span>Next billing date:</span> {moment.unix(data.subscription.next_billing_at).format('DD MMM YYYY')}
          </p>
        ) : (
          <p>
            <span>Cancellation date:</span> {moment.unix(data.subscription.current_term_end).format('DD MMM YYYY')}
          </p>
        )}

        {data.subscription.status == 'active' && (
          <Confirm
            onConfirm={this.handleSwitch}
            title={'Turn off auto-renewal'}
            body={
              <p>
                Your subscription will be cancelled on <br />
                <b>{moment.unix(data.subscription.current_term_end).format('DD MMM YYYY')}</b>. Are you sure?
              </p>
            }
            icon={saveIcon}
            confirmClass="btn-primary"
            confirmText="Confirm"
          >
            <div>
              <Switch
                id="auto-renewal"
                name="auto-renewal"
                label="Auto-renewal:"
                ref={this.switchRef}
                checked={this.state.autorenewal}
                readOnly
              />
            </div>
          </Confirm>
        )}
        {data.subscription.status == 'non_renewing' && (
          <div>
            <Switch 
              label="Auto-renewal:"
              ref={this.switchRef} 
              checked={this.state.autorenewal} 
              onChange={this.handleSwitch} />
          </div>
        )}
        {data.subscription.status == 'cancelled' && (
          <div>
            <Button className="btn btn-primary" onClick={this.handleReactivate}>
              {reactivating ? 'Loading...' : 'Reactivate subscription'}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reactivateSubscription: () => dispatch(reactivateSubscription()),
    toggleAutorenewal: (val) => dispatch(toggleAutorenewal(val)),
  };
};

function mapStateToProps(state) {
  const dashboards = state.dashboards.list.length || state.auth.user.dashboards;
  return {
    app: state.app.app,
    allowedDashboards: state.auth.user.allowedDashboards,
    dashboards,
    reactivating: state.billing.reactivating,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscription));
